import Vue from "vue";
import Vuex from "vuex";

import chat from "@/store/chat";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    siteInfo: {},
    // 岗位检索是否带地图
    searchWithLocation: false,
    tabbar: [],
    sceneId: undefined,
    shareConfig: [],
    editRegionList: [],
    filterRegionList: [],
    noAllRegionList: [],
    cates: {},
  },
  mutations: {
    setShareConfig(state, payload) {
      state.shareConfig = payload;
    },
    setSearchWithLocation(state, payload) {
      this.state.searchWithLocation = payload;
    },
    setSiteInfo(state, payload) {
      state.siteInfo = payload;
      // 设置直聊





































































      state.tabbar = [
        {
          iconPath: "/static/images/icons/home/home.png",
          selectedIconPath: "/static/images/icons/home/home-active.png",
          text: "首页",
          pagePath: "/pages/index/index",
        },
        {
          iconPath: "/static/images/icons/home/company.png",
          selectedIconPath: "/static/images/icons/home/company-active.png",
          text: "企业",
          pagePath: "/pages/company/list",
        },
        {
          iconPath: "/static/images/icons/home/job.png",
          selectedIconPath: "/static/images/icons/home/job-active.png",
          text: "岗位",
          pagePath: "/pages/recruit/list",
        },
        {
          iconPath: "/static/images/icons/home/chat.png",
          selectedIconPath: "/static/images/icons/home/chat-active.png",
          text: "聊天",
          // 红色角标显示的数字，如果需要移除角标，配置此参数为0即可
          count: 0,
          // 如果配置此值为true，那么角标将会以红点的形式显示
          // isDot: true,
          pagePath: "/pages/chat/index",
        },
        {
          iconPath: "/static/images/icons/home/my.png",
          selectedIconPath: "/static/images/icons/home/my-active.png",
          text: "我的",
          pagePath: "/pages/my/my",
        },
      ];

    },
    setNoReadNumTabbar(state, noReadNum) {





































































      state.tabbar = [
        {
          iconPath: "/static/images/icons/home/home.png",
          selectedIconPath: "/static/images/icons/home/home-active.png",
          text: "首页",
          pagePath: "/pages/index/index",
        },
        {
          iconPath: "/static/images/icons/home/company.png",
          selectedIconPath: "/static/images/icons/home/company-active.png",
          text: "企业",
          pagePath: "/pages/company/list",
        },
        {
          iconPath: "/static/images/icons/home/job.png",
          selectedIconPath: "/static/images/icons/home/job-active.png",
          text: "岗位",
          pagePath: "/pages/recruit/list",
        },
        {
          iconPath: "/static/images/icons/home/chat.png",
          selectedIconPath: "/static/images/icons/home/chat-active.png",
          text: "聊天",
          // 红色角标显示的数字，如果需要移除角标，配置此参数为0即可
          count: noReadNum,
          // 如果配置此值为true，那么角标将会以红点的形式显示
          // isDot: true,
          pagePath: "/pages/chat/index",
        },
        {
          iconPath: "/static/images/icons/home/my.png",
          selectedIconPath: "/static/images/icons/home/my-active.png",
          text: "我的",
          pagePath: "/pages/my/my",
        },
      ];

    },

    SET_STATE(state, payload) {
      if (payload == 1) {
        state.tabbar = [
          {
            iconPath: "/static/images/icons/home/home.png",
            selectedIconPath: "/static/images/icons/home/home-active.png",
            text: "首页",
            pagePath: "/pages/index/index",
          },
          {
            iconPath: "/static/images/icons/home/company.png",
            selectedIconPath: "/static/images/icons/home/company-active.png",
            text: "企业",
            pagePath: "/pages/company/searchList",
          },
          {
            iconPath: "/static/images/icons/plus.png",
            selectedIconPath: "/static/images/icons/del.png",
            text: "",
            midButton: true,
            pagePath: "/pagesMy/my/recruiter/resumePublish",
          },
          {
            iconPath: "/static/images/icons/home/chat.png",
            selectedIconPath: "/static/images/icons/home/chat-active.png",
            text: "消息",
            pagePath: "/pages/message/message",
          },
          {
            iconPath: "/static/images/icons/home/my.png",
            selectedIconPath: "/static/images/icons/home/my-active.png",
            text: "我的",
            pagePath: "/pages/my/my",
          },
        ];
      } else if (payload == 2) {
        state.tabbar = [
          {
            iconPath: "/static/images/icons/home/home.png",
            selectedIconPath: "/static/images/icons/home/home-active.png",
            text: "首页",
            pagePath: "/pages/index/index",
          },
          {
            iconPath: "/static/images/icons/home/company.png",
            selectedIconPath: "/static/images/icons/home/company-active.png",
            text: "企业",
            pagePath: "/pages/company/searchList",
          },
          {
            iconPath: "/static/images/icons/plus.png",
            selectedIconPath: "/static/images/icons/del.png",
            text: "",
            midButton: true,
            pagePath: "/pages/resumeUser/infoRegister",
          },
          {
            iconPath: "/static/images/icons/home/chat.png",
            selectedIconPath: "/static/images/icons/home/chat-active.png",
            text: "消息",
            pagePath: "/pages/message/message",
          },
          {
            iconPath: "/static/images/icons/home/my.png",
            selectedIconPath: "/static/images/icons/home/my-active.png",
            text: "我的",
            pagePath: "/pages/my/my",
          },
        ];
      }
    },
    CHANGE_SET_VALUE: (state, { key, value }) => {
      if (state.hasOwnProperty(key)) {
        state[key] = value;
      }
    },
    setEditRegionList(state, payload) {
      state.editRegionList = payload;
    },
    setFilterRegionList(state, payload) {
      state.filterRegionList = payload;
    },
    setNoAllRegionList(state, payload) {
      state.noAllRegionList = payload;
    },
    setCates(state, payload) {
      state.cates = payload;
    },
  },
  action: {
    setValue({ commit }, data) {
      return new Promise((resolve) => {
        commit("CHANGE_SET_VALUE", data);
        resolve();
      });
    },
  },
});

export default store;
